import { MessageCircle, Phone } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { CONTACT, TRIAL_WA } from "../data/content";

export const FinalCTA = () => (
  <section id="contact" className="py-24 sm:py-32 scroll-mt-16 border-t border-white/8" data-testid="final-cta-section">
    <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
      <Reveal>
        <p className="text-[10px] sm:text-xs tracking-[0.28em] uppercase text-[#D4AF37] font-semibold">Ready When You Are</p>
        <h2 className="font-heading text-3xl sm:text-5xl lg:text-6xl font-black uppercase tracking-tight mt-4 leading-[1.05]">
          Ready to start your<br className="hidden sm:block" /> <span className="text-[#D4AF37]">Zavi journey?</span>
        </h2>
        <p className="mt-5 text-white/70 text-base sm:text-lg max-w-xl mx-auto">
          Experience the Zavi training environment before making a decision.
        </p>
      </Reveal>
      <Reveal delay={0.15}>
        <div className="mt-10 flex flex-col sm:flex-row items-center justify-center gap-3">
          <a href={TRIAL_WA} target="_blank" rel="noreferrer" data-testid="final-cta-trial"
            className="w-full sm:w-auto bg-[#D4AF37] text-black font-bold uppercase tracking-widest text-sm px-8 py-4 text-center hover:bg-[#F3D059] hover:-translate-y-0.5 transition-all duration-200 gold-glow">
            Book Your Free Trial
          </a>
          <a href={CONTACT.whatsapp} target="_blank" rel="noreferrer" data-testid="final-cta-whatsapp"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 border border-[#D4AF37] text-[#D4AF37] font-bold uppercase tracking-widest text-sm px-8 py-4 hover:bg-[#D4AF37] hover:text-black transition-colors duration-200">
            <MessageCircle size={16} /> WhatsApp Us
          </a>
          <a href={`tel:${CONTACT.phoneRaw}`} data-testid="final-cta-call"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 text-white/70 font-semibold uppercase tracking-widest text-sm px-4 py-4 hover:text-[#D4AF37] transition-colors duration-200">
            <Phone size={14} /> Call Us
          </a>
        </div>
      </Reveal>
    </div>
  </section>
);
